<template>
  <div class="video-div" @click="hideVideo">
    <video width="75%" controls autoplay loop>
      <source src="https://cdnblobendpoint.azureedge.net/bezzina-static/video/frontpage-demo-video.mp4" type="video/mp4">
      HTML5 video not supported by this browser
    </video>
  </div>
</template>

<script>
export default {
  methods: {
    hideVideo () {
      this.$emit('hideVideo')
    }
  }
}
</script>

<style scoped>
.video-div {
  position: fixed;
  padding: 0;
  margin: 0;

  top: 0;
  left: 0;

  /*display: block;*/
  width: 100%;
  height: 108%;
  background: rgba(0, 0, 0, 0.8);
  /*margin: 0 auto;*/
  text-align: center;
  z-index: 99;
}
video {
  margin-top: 10vh;
  z-index: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/VideoPlayer.vue